import { RouterProvider } from 'react-router-dom';

// project imports
import router from './routes';
import ThemeCustomization from './themes/index';

import ScrollTop from './components/ScrollTop';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <HelmetProvider>
      <ThemeCustomization>
        <ScrollTop>
          <Toaster position='top-right' richColors />
          <RouterProvider router={router} />
        </ScrollTop>
      </ThemeCustomization>
    </HelmetProvider>
  );
}
